import { components as allauthComponents } from "@/lib/AllauthApiSchema";
import {
  Microsoft as MicrosoftIcon,
  Outlook as OutlookIcon,
} from "@ridemountainpig/svgl-react";
import { SVGProps } from "react";

type ProviderIconProps = {
  provider: allauthComponents["schemas"]["Provider"]["id"];
} & SVGProps<SVGSVGElement>;

export default function ProviderIcon({
  provider,
  ...props
}: ProviderIconProps) {
  switch (provider) {
    case "microsoft":
      return <MicrosoftIcon {...props} />;
    case "microsoft_email":
      return <OutlookIcon {...props} />;
    default:
      return null;
  }
}
